// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1ZBuV","content":"styles_content__1U0L5","selectAll":"styles_selectAll__25I4J"};